import { createPatchEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PatchSonarTaskTemplateConfigRequest = {
	organizationId: number;
	taskType: string;
	minDaysInterval?: number;
	enabled?: boolean;
	shardName?: string;
};

export const patchSonarTaskTemplateConfig =
	createPatchEndpoint<PatchSonarTaskTemplateConfigRequest, void>(
		(request) => `/api/v3/core/organizations/${request.organizationId}/tasks/${request.taskType}/config`,
		{
			headers: (request) => {
				if (request?.shardName) {
					return { [ HttpHeader.Shard ]: request.shardName };
				}

				return {};
			},
			requestTransform: (request) => ({
				enabled: request.enabled,
				minDaysInterval: request.minDaysInterval
			})
		}
	);
